module.exports = __webpack_public_path__ + "img/coffin.9678f267.svg";